import React from 'react'

function Who() {
  return (
   <section className="container-fluid p-3 p-md-5 bg-dark">
    <div className="row align-items-center">
        <div className="col-md-5 text-center">
            <img src="https://img.freepik.com/premium-photo/abstract-monochrome-image-street-bulb-suprematism-style_183314-6447.jpg?ga=GA1.1.1538238808.1729515699&semt=ais_hybrid" alt="" className="w-100 rounded" />
        </div>
        <div className="col-md-7">
            <h1 className="fs-1 fw-bold text-aqua">Who are we ?</h1>
            <p className="fs-5 text-white">
            <span className="text-aqua">Rocketshots</span> was instantiated on  5th Aug  2022 by Ranav kshirsagr and  Likith Raj experienced pioneers of the digital world. We at  Rocket shots provide world-class quality to our client content and uplift their Digital paradigm by bringing the best in class talents to work together and deliver engaging content to transforming your ideas into reality
            </p>
        </div>
    </div>
   </section>
  )
}

export default Who